import React from 'react';
import { InfluencerProfileView } from '@/domains/influencers';

const InfluencerProfilePage: React.FC = () => {
  return <InfluencerProfileView />;
};

export default InfluencerProfilePage;
